<template>

    <!-- OWN MESSAGE -->
    <div class="d-flex justify-end" v-if="$store.state.user.id === user.id">

        <div v-if="createdAt" class="caption text-no-wrap grey--text ml-2">
            {{ formatTime(createdAt) }}
        </div>

        <div class="speech-bubble-me ml-3 mr-3 elevation-1">

            <div class="d-flex pa-1">
                <div class="body-2 pr-2 align-self-center">
                    {{ message }}
                </div>

                <div class="body-2 pl-2 align-self-center">
                    <avatar :size="30" :image-url="$store.state.user.photo_url" :person-name="$store.state.user.name">
                        {{ $store.state.user.name }}
                    </avatar>
                </div>
            </div>

        </div>

    </div>

    <!-- SOMEBODY ELSE's MESSAGE -->
    <div v-else class="d-flex justify-start">
        <div class="speech-bubble-person ml-3 mr-3 elevation-1">
            <div class="d-flex pa-1">

                <div class="body-2 pl-2 align-self-center">
                    <avatar :size="30" :image-url="user.photo_url" :person-name="user.name">{{ user.name }}</avatar>
                </div>

                <div class="body-2 pl-2 align-self-center">
                    {{ message }}
                </div>

            </div>
        </div>

        <div v-if="createdAt" class="caption text-no-wrap grey--text mr-2">
            {{ formatTime(createdAt) }}
        </div>
    </div>

</template>

<script>

import Avatar from '../../../components/UI/Avatar';
import {timeDisplay} from "../../../components/mixins/timeDisplayMixin";

export default {

    mixins: [
        timeDisplay
    ],

    components: {
        Avatar
    },

    props: {
        message: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true,
        },
        createdAt: {
            type: String,
            required: false,
            default: false,
        }
    },
}
</script>

<style scoped>

.speech-bubble-me {
    background-color: #1565C0;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    font-size: 1.2rem;
    line-height: 1.3;
    margin: 0 auto 30px;
    max-width: 400px;
    padding-left: 5px;
    padding-right: 5px;
    position: relative;
}

.speech-bubble-me p {
    margin: 0 0 10px;
}

.speech-bubble-me p:last-of-type {
    margin-bottom: 0;
}

.speech-bubble-me::after {
    border-left: 10px solid transparent;
    border-top: 10px solid #1565C0;
    bottom: -10px;
    content: "";
    position: absolute;
    right: 4px;
    z-index:100;
}

.speech-bubble-person {
    background-color: #666;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    font-size: 1.2rem;
    line-height: 1.3;
    margin: 0 auto 30px;
    max-width: 400px;
    padding-left: 5px;
    padding-right: 5px;
    position: relative;
}

.speech-bubble-person p {
    margin: 0 0 10px;
}

.speech-bubble-person p:last-of-type {
    margin-bottom: 0;
}

.speech-bubble-person::after {
    border-right: 10px solid transparent;
    border-top: 10px solid #666;
    bottom: -10px;
    content: "";
    position: absolute;
    left: 4px;
    box-shadow: 10px 10px 18px -8px rgba(0, 0, 0, 0.5);
}
</style>